export default "__VITE_ASSET__bd660aa8__"